import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase';
import { uploadImage } from '../firebase/images';
import { useAuth } from '../contexts/AuthContext';

const containerStyle: React.CSSProperties = {
  maxWidth: 600,
  margin: '0 auto',
  padding: 20,
};

const titleStyle: React.CSSProperties = {
  margin: '0 0 24px',
  fontSize: 24,
};

const formStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
};

const inputStyle: React.CSSProperties = {
  padding: 8,
  border: '1px solid #ddd',
  borderRadius: 4,
  fontSize: 16,
};

const textAreaStyle: React.CSSProperties = {
  padding: 8,
  border: '1px solid #ddd',
  borderRadius: 4,
  fontSize: 16,
  minHeight: 100,
  resize: 'vertical' as const,
};

const buttonStyle: React.CSSProperties = {
  background: '#007bff',
  color: 'white',
  border: 'none',
  padding: 12,
  borderRadius: 4,
  cursor: 'pointer',
  fontSize: 16,
};

const previewStyle: React.CSSProperties = {
  maxWidth: '100%',
  maxHeight: 300,
  objectFit: 'contain',
  marginTop: 16,
};

export const UploadImage: React.FC = () => {
  const [title, setTitle] = useState('');
  const [file, setFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0];
    if (selectedFile) {
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result as string);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!file || !currentUser) return;

    setLoading(true);
    try {
      const storageRef = ref(storage, `images/${Date.now()}_${file.name}`);
      await uploadBytes(storageRef, file);
      const imageUrl = await getDownloadURL(storageRef);

      await uploadImage({
        imageUrl,
        title,
        authorId: currentUser.uid,
        authorName: currentUser.name || '익명'
      });

      navigate('/makecodearcade');
    } catch (error) {
      console.error('Error uploading image:', error);
      alert('이미지 업로드 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={containerStyle}>
      <h1 style={titleStyle}>이미지 업로드</h1>
      <form style={formStyle} onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="제목을 입력하세요"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
          style={inputStyle}
        />
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          required
          style={inputStyle}
        />
        {preview && <img src={preview} alt="미리보기" style={previewStyle} />}
        <button
          type="submit"
          disabled={loading || !file || !title}
          style={{
            ...buttonStyle,
            ...((loading || !file || !title) ? { background: '#ccc', cursor: 'not-allowed' } : {}),
          }}
        >
          {loading ? '업로드 중...' : '업로드'}
        </button>
      </form>
    </div>
  );
};
